module.exports = __webpack_public_path__ + "ab34a77ba91f2f7a6f4b7b223cda3e30.png";